import React from 'react';

export const PlusIcon = ({ nameOfClass }) => (
    <svg className={nameOfClass} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.71429 5.78571H10.5V6.21429H6.71429H6.21429V6.71429V10.5H5.78571V6.71429V6.21429H5.28571H1.5V5.78571H5.28571H5.78571V5.28571V1.5H6.21429V5.28571V5.78571H6.71429Z" />
    </svg>
);
